/**
 * Module dependencies.
 */

import { ReactElement } from 'react';
import { media, units } from '@untile/react-components';
import { orderedNewsExhibitionsCategories } from 'src/core/content-config/news-exhibitions';
import Filter from 'src/components/news-exhibitions/filters';
import styled from 'styled-components';
import useTranslate from 'src/hooks/use-translate';

/**
 * `FiltersWrapper` styled component.
 */

const FiltersWrapper = styled.ul`
  display: flex;
  grid-gap: ${units(2)};
  padding-top: 50px;

  ${media.min('ms')`
    padding-top: ${units(8)};
  `}
`;

/**
 * `NewsExhibitionsFilters` component.
 */

const NewsExhibitionsFilters = (): ReactElement => {
  const { translate } = useTranslate();

  return (
    <FiltersWrapper>
      <Filter
        name={translate('news-exhibitions:categories.all')}
        type={'all'}
      />

      {orderedNewsExhibitionsCategories.map(category => (
        <Filter
          key={category}
          name={translate(`news-exhibitions:categories.${category}`)}
          type={category}
        />
      ))}
    </FiltersWrapper>
  );
};

/**
 * Export `NewsExhibitionsFilters` component.
 */

export default NewsExhibitionsFilters;
